/** Пороговые значения, вынесенные из кода правил, чтобы менять их в одном месте. */

/** Порог из п. 2 ст. 213.3 Закона о банкротстве — 500 000 ₽ (правила R-09/R-10). */
export const DEBT_THRESHOLD_KOPECKS = 500_000_00;

/** Период, за который раскрываются сделки, — три года (ТЗ п. 5.2.8). */
export const DEALS_PERIOD_YEARS = 3;
